import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Rakenda

  <span style="color:#85c1dc;">**FI:**</span>
  Käytä

  <span style="color:#85c1dc;">**RU:**</span>
  Применить
*/
/* @__NO_SIDE_EFFECTS__ */
const m1902 = msg(
  mf`Rakenda`,
  mf`Käytä`,
  mf`Применить`,
)

export { m1902 as 'w.module.options_bar.apply' }